export const RUTA_COBROS_TIME_ZONE = 'America/Guatemala';

/** Returns a YYYY-MM-DD business date without depending on the browser zone. */
export function todayInTimeZone(
  now: Date = new Date(),
  timeZone: string = RUTA_COBROS_TIME_ZONE,
): string {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

/** Formats a payment instant in the operational timezone for the timeline. */
export function formatRutaCobroTime(
  value: Date | string,
  locale = 'es',
  timeZone: string = RUTA_COBROS_TIME_ZONE,
): string | null {
  const instant = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(instant.getTime())) return null;

  const resolvedLocale = locale.toLowerCase().startsWith('en') ? 'en-US' : 'es-GT';
  return new Intl.DateTimeFormat(resolvedLocale, {
    timeZone,
    hourCycle: 'h23',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(instant);
}

/** Formats a payment registration instant with its operational date and time. */
export function formatRutaCobroRegistrationTime(
  value: Date | string,
  locale = 'es',
  timeZone: string = RUTA_COBROS_TIME_ZONE,
): string | null {
  const instant = value instanceof Date ? value : new Date(value);
  if (!Number.isFinite(instant.getTime())) return null;

  const resolvedLocale = locale.toLowerCase().startsWith('en') ? 'en-US' : 'es-GT';
  return new Intl.DateTimeFormat(resolvedLocale, {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hourCycle: 'h23',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(instant);
}
